import { bindable, inject } from 'aurelia';
import { UserContext } from '../contexts/user-context';

@inject(UserContext)
export class NavBar {
  @bindable public homeUrl: string;
  @bindable public baseUrl: string;

  constructor(public userContext: UserContext) {}

  public signOut(): void {
    window.location.href = '/auth/signout';
  }

  public collapseMenu(): void {
    const menu = document.getElementById('navbar-div');
    if (!menu || !menu.classList.contains('show')) {
      return;
    }

    menu.classList.remove('show');

    const toggler = document.querySelector<HTMLButtonElement>('.navbar-toggler');
    toggler?.classList.add('collapsed');
    toggler?.setAttribute('aria-expanded', 'false');
  }
}
